export const FREIGHT_TABLE_HISTORY_EVENTS = [
  { value: "created", label: "Tabela criada" },
  { value: "updated", label: "Detalhes atualizados" },
  { value: "finalized", label: "Tabela finalizada" },
  { value: "deleted", label: "Tabela excluída" },
  { value: "status_changed", label: "Status alterado" },
  { value: "route_added", label: "Rota adicionada" },
  { value: "route_updated", label: "Rota atualizada" },
  { value: "vigencia_added", label: "Vigência incluída" },
  {
    value: "pessoa_added,transportador_added",
    label: "Transportadora vinculada",
  },
  {
    value: "pessoa_removed,transportador_removed",
    label: "Transportadora desvinculada",
  },
];
